import React, { useMemo, useCallback } from 'react';
import Api, { exceptionNotificationAPI } from '../../services/api';
import TableCrudEnhanced from '../../components/TableCrudEnhanced';
import moment from 'moment';

const FSMIntegrationLogsIndex = () => {
    const getFile = useCallback(async (fileName) => {
        try {
            const res = await Api.get(`FSMIntegrationData/getFile/${fileName}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(res.data);
            window.open(url);
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }, []);

    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Description..."
        },
        {
            type: "text",
            name: "fileName",
            label: "Filename",
            placeholder: "Filename..."
        },
        {
            type: "text",
            name: "companyName",
            label: "Company",
            placeholder: "Company name..."
        },
        {
            type: "text",
            name: "moduleDescription",
            label: "Module",
            placeholder: "Module description..."
        }
    ], []);

    const columns = useMemo(() => [
        {
            title: "ID",
            dataIndex: "fsmIntegrationLogID",
            key: "fsmIntegrationLogID",
            sortable: true,
            width: 80
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            sortable: true
        },
        {
            title: "Company",
            dataIndex: "company.name",
            key: "company.name",
            sortable: true
        },
        {
            title: "Crop",
            dataIndex: "reportYear.year",
            key: "reportYear.year",
            sortable: true
        },
        {
            title: "Module",
            dataIndex: "module.description",
            key: "module.description",
            sortable: true
        },
        {
            title: "Filename",
            dataIndex: "fileName",
            key: "fileName",
            sortable: true,
            render: (value, record) => (
                <span
                    style={{ textDecoration: 'underline', color: '#5c8fff', fontWeight: 700, cursor: 'pointer' }}
                    onClick={() => getFile(record.fileName)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') getFile(record.fileName); }}
                >
                    {value || '-'}
                </span>
            )
        },
        {
            title: "Created Date",
            dataIndex: "created",
            key: "created",
            sortable: true,
            type: "date",
            render: (value) => value ? moment.utc(value).local().format("DD/MM/YYYY HH:mm:ss") : '-'
        }
    ], [getFile]);

    return (
        <TableCrudEnhanced
            title="FSM Integration Data - Importation Logs"
            apiEndpoint="/FSMIntegrationLog/getAllPaginated"
            columns={columns}
            filterConfig={filterConfig}
            actions={[]}
            rowKey="fsmIntegrationLogID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={false}
        />
    );
};

export default FSMIntegrationLogsIndex;
